const selectSong = song => ({
  type: 'SONG_SELECTED',
  payload: song,
});

export default selectSong;
